import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AffiliateMarketingRoutingModule } from './affiliate-marketing-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AffiliateMarketingRoutingModule
  ]
})
export class AffiliateMarketingModule { }
